import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

const assignDriver = createAction(`${nameSpace}/assignDriver`);
const cancelTrip = createAction(`${nameSpace}/cancel`);
const printTripDetails = createAction(`${nameSpace}/printTripDetails`);
const printTripList = createAction(`${nameSpace}/printTripList`);

export default {
  assignDriver,
  cancelTrip,
  printTripDetails,
  printTripList,
};
